module.exports = __webpack_public_path__ + "static/img/avatar-s-11.51a23c07.png";